var map = {
	"./堰月.jpg": 6970,
	"./榴弹发射器.jpg": 7449,
	"./狙击步枪.jpg": 818,
	"./融合步枪.jpg": 5094,
	"./追踪步枪.jpg": 6674,
	"./霰弹枪.jpg": 5139
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1042;